var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.82667 15.0273C10.7467 18.8006 13.84 21.8806 17.6133 23.814L20.5467 20.8806C20.9067 20.5206 21.44 20.4006 21.9067 20.5606C23.4 21.054 25.0133 21.3206 26.6667 21.3206C27.4 21.3206 28 21.9206 28 22.654V27.3073C28 28.0406 27.4 28.6406 26.6667 28.6406C14.1467 28.6406 4 18.494 4 5.97396C4 5.24063 4.6 4.64062 5.33333 4.64062H10C10.7333 4.64062 11.3333 5.24063 11.3333 5.97396C11.3333 7.64063 11.6 9.24063 12.0933 10.734C12.24 11.2006 12.1333 11.7206 11.76 12.094L8.82667 15.0273Z",
    fill: "url(#paint0_linear_98_594)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_98_594",
    x1: 16,
    y1: 4.64063,
    x2: 39.8772,
    y2: 22.0269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#044945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#541DBB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.95f28525db66eddbdbc72b9ee92d6fc3.svg";
export { ForwardRef as ReactComponent };